// extracted by mini-css-extract-plugin
module.exports = {"close":"CloseButton_close__2_MLd","top":"CloseButton_top__3553A"};